import { MaskedInput } from "@expert/common-ui";
import { ActionIcon, Flex, Text } from "@mantine/core";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useState } from "react";

import type { GuideTextInput } from "../logic-builder";

import classes from "./GuideCardInput.module.css";

interface GuideCardInputProps {
    textInput: GuideTextInput;
    value: string;
    onInput: (val: string) => void;
    /** Hide the value behind dots, with an eye button to show it. For secrets such as a PIN. */
    masked?: boolean;
    validationError?: string;
}

export function GuideCardInput({ textInput, validationError, value, onInput, masked = false }: GuideCardInputProps) {
    const [revealed, setRevealed] = useState(false);
    // the parent clears the value on submit and retry, so each fresh attempt starts hidden again
    if (!value && revealed) setRevealed(false);
    const isHidden = masked && !revealed;
    const toggleLabel = revealed ? "Hide PIN" : "Show PIN";

    return (
        <Flex direction="column" w="100%">
            {validationError && (
                <Text size="xs" c="var(--mantine-color-red-text)">
                    {validationError}
                </Text>
            )}
            <MaskedInput
                value={value}
                onInput={(e) => onInput(e.currentTarget.value)}
                mask={textInput.mask}
                type={isHidden ? "password" : textInput.inputType}
                inputMode={masked && textInput.inputType === "tel" ? "numeric" : undefined}
                autoComplete={masked ? "off" : undefined}
                placeholder={textInput.placeholder}
                w="80%"
                maw="12rem"
                h="2.5rem"
                error={!!validationError}
                className="fs-mask"
                rightSectionPointerEvents={masked ? "all" : undefined}
                rightSection={
                    masked ? (
                        <ActionIcon
                            variant="subtle"
                            color="gray"
                            classNames={{ root: classes.toggle }}
                            aria-label={toggleLabel}
                            aria-pressed={revealed}
                            // keep focus in the input so the expert can keep typing
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => setRevealed((prev) => !prev)}
                        >
                            {revealed ? <IconEyeOff size={16} /> : <IconEye size={16} />}
                        </ActionIcon>
                    ) : undefined
                }
            />
        </Flex>
    );
}
